export const REVEAL_DURATION_MS = 1200;
export const REVEAL_DELAY_MS = 180;
export const BAR_ANIMATION_MS = 1400;

export const toMs = (value: number) => `${value}ms`;
